import { useEffect, useRef, useState } from "react";
import { wsURL } from "../lib/api";

export function useLiveWS(onEvent) {
  const wsRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;

  useEffect(() => {
    let closed = false;
    let retry = 0;
    let timer = null;

    const connect = () => {
      if (closed) return;
      const ws = new WebSocket(wsURL());
      wsRef.current = ws;
      ws.onopen = () => {
        setConnected(true);
        retry = 0;
      };
      ws.onmessage = (evt) => {
        try {
          const msg = JSON.parse(evt.data);
          onEventRef.current && onEventRef.current(msg);
        } catch (_) {}
      };
      ws.onclose = () => {
        setConnected(false);
        if (!closed) {
          retry += 1;
          timer = setTimeout(connect, Math.min(5000, 500 * retry));
        }
      };
      ws.onerror = () => {
        try { ws.close(); } catch (_) {}
      };
    };

    connect();
    return () => {
      closed = true;
      if (timer) clearTimeout(timer);
      if (wsRef.current) {
        try { wsRef.current.close(); } catch (_) {}
      }
    };
  }, []);

  return { connected };
}
